import { Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import arrowBack from 'assets/icons/arrow-back.svg'
import { useIsCompactMenu } from 'shared/hooks/useIsCompactMenu'
import styles from './MainTitle.module.scss'

interface IMainTitleProps {
  text: string
  id?: string
  isGoBack?: boolean
  onGoBack?: () => void
  style?: React.CSSProperties
  // на телефоне и планшете раздел понятен из таббара и меню кабинета — заголовок не дублируем
  hideOnMobile?: boolean
}

export const MainTitle: React.FC<IMainTitleProps> = ({ text, id, style, isGoBack = false, onGoBack, hideOnMobile = false }) => {
  const navigate = useNavigate()
  const isCompactMenu = useIsCompactMenu()

  if (hideOnMobile && isCompactMenu) {
    return null
  }

  return (
    <div className={styles.wrapper} style={style}>
      {isGoBack && (
        <button
          type='button'
          className='reset-button'
          onClick={() => {
            if (onGoBack) {
              return onGoBack()
            }
            navigate(-1)
          }}
        >
          <img src={arrowBack} alt='Вернуться назад' />
        </button>
      )}
      <Typography.Title id={id} className={styles.title}>{text}</Typography.Title>
    </div>
  )
}
